import React from 'react'
import moment from 'moment'
import SuperDiabetesChild from './SuperDiabetesChild'
import SuperDiabetesChildCal from './SuperDiabetesChildCal'
import DiabetesActions from '../Actions/DiabetesActions'
import Calculos from './Calculos'

import { hashHistory } from 'react-router'

export default class SuperDiabetesForm extends React.Component {

    constructor (props) {
        super (props)
        this.state=({
            data:[],
            calculos:[],
            resultados:[{}]
        })
        this.diabetesActions =  new DiabetesActions()
    }

    componentDidMount () {
      this.diabetesActions.diabetes(this.props.params.patient, (diabetes) => {
        this.setState({data:diabetes.datosMedicos,calculos:diabetes.datosmedicosCal, resultados:diabetes.Calculos})
      })

    }


    render () {
      var jsObj = this.state.data
      var jsObjCal = this.state.calculos
      var jsResultados = this.state.resultados

        return (
            <div className="Supermedical">
                Diabetes
                <h3>Gestion de controles datos medicos</h3>
                {jsObj.length > 0?
                 <div className="control">
                  <SuperDiabetesChild data={jsObj} onDelete={() => this.refresh()}/>
                 </div>
                : "El Paciente no tiene Controles."}
                <h3>Gestion de calculos para Controles</h3>
                {jsObjCal.length > 0?
                 <div className="control">
                 <SuperDiabetesChildCal data={jsObjCal} onDelete={() => this.refresh()} />
                 </div>
                : "El Paciente no tiene Controles."}
                <Calculos data={jsResultados} />


            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Patient/SuperDiabetesForm.js